export default __webpack_public_path__ + "9f5bdeaa4791672a140755e12929d0a8.ttf";